module.exports = __webpack_public_path__ + "img/inform.f7d457e4.png";